import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Sparkles } from "lucide-react";
import { SITE } from "../lib/api";

const INSTAGRAM_URL = "https://www.instagram.com/rosalvo_oficial?igsh=MWF5NmJ6NjR6cW50bQ==";

// QR code generator via free API (Goqr)
const QR_SIZE = 320;
const QR_URL = `https://api.qrserver.com/v1/create-qr-code/?size=${QR_SIZE}x${QR_SIZE}&data=${encodeURIComponent(INSTAGRAM_URL)}&margin=10&qzone=2&color=003F88&bgcolor=FFFFFF`;

export default function MaintenancePage() {
  return (
    <div data-testid="page-maintenance" className="min-h-screen bg-[#003F88] text-white relative overflow-hidden flex flex-col">
      {/* Decorative shapes */}
      <div className="absolute -top-32 -right-32 w-96 h-96 bg-[#FFC72C]/10 rounded-full blur-3xl" />
      <div className="absolute -bottom-40 -left-40 w-[28rem] h-[28rem] bg-[#FFC72C]/10 rounded-full blur-3xl" />

      {/* Top bar */}
      <header className="relative z-10 px-6 md:px-12 py-6 md:py-8 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <span className="inline-flex items-center justify-center w-10 h-10 md:w-12 md:h-12 bg-[#FFC72C] text-[#003F88] font-serif-display text-2xl md:text-3xl font-semibold leading-none">
            R
          </span>
          <div className="leading-tight">
            <div className="font-serif-display text-lg md:text-xl">{SITE.name}</div>
            <div className="text-[9px] md:text-[10px] uppercase tracking-[0.22em] text-white/60">
              {SITE.party} · {SITE.city}
            </div>
          </div>
        </div>
        <Link
          to="/admin/login"
          data-testid="maintenance-admin-link"
          className="text-[10px] md:text-xs uppercase tracking-widest text-white/50 hover:text-[#FFC72C] transition-colors"
        >
          Acesso interno
        </Link>
      </header>

      {/* Center content */}
      <main className="relative z-10 flex-1 flex items-center justify-center px-6 md:px-12 py-10">
        <div className="max-w-5xl w-full grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          {/* Left: Message */}
          <div className="lg:col-span-7 text-center lg:text-left order-2 lg:order-1">
            <div className="inline-flex items-center gap-2 text-[10px] md:text-xs uppercase tracking-[0.28em] text-[#FFC72C] font-semibold mb-6">
              <Sparkles size={14} /> Site em reconstrução
            </div>
            <h1 className="font-serif-display text-5xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tight">
              Estamos preparando uma
              <br />
              <em className="italic font-light text-[#FFC72C]">nova fase</em>
              <br />
              do nosso site.
            </h1>
            <p className="mt-8 text-base md:text-lg text-white/80 font-light leading-relaxed max-w-xl mx-auto lg:mx-0">
              Enquanto isso, siga e acompanhe tudo pelo Instagram oficial
              <span className="text-[#FFC72C] font-medium"> {SITE.instagramHandle}</span> —
              é lá que o trabalho continua, em tempo real.
            </p>
            <div className="mt-10 flex flex-wrap justify-center lg:justify-start gap-3">
              <a
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noreferrer"
                data-testid="maintenance-ig-btn"
                className="inline-flex items-center gap-3 bg-[#FFC72C] text-[#003F88] px-7 py-4 text-xs uppercase tracking-[0.2em] font-bold hover:bg-white transition-colors"
              >
                <Instagram size={16} /> Abrir Instagram
              </a>
              <a
                href={`https://wa.me/${SITE.whatsapp}`}
                target="_blank"
                rel="noreferrer"
                data-testid="maintenance-wa-btn"
                className="inline-flex items-center gap-3 border-2 border-white/30 text-white px-7 py-[14px] text-xs uppercase tracking-[0.2em] font-medium hover:bg-white hover:text-[#003F88] hover:border-white transition-colors"
              >
                Falar pelo WhatsApp
              </a>
            </div>
          </div>

          {/* Right: QR Code */}
          <div className="lg:col-span-5 order-1 lg:order-2 flex flex-col items-center">
            <div className="relative">
              <div className="absolute -inset-3 bg-[#FFC72C]" />
              <div className="relative bg-white p-6 md:p-7">
                <img
                  src={QR_URL}
                  alt="QR Code para Instagram @rosalvo_oficial"
                  data-testid="maintenance-qrcode"
                  width={QR_SIZE}
                  height={QR_SIZE}
                  className="block"
                />
              </div>
            </div>
            <div className="mt-8 text-center">
              <div className="text-[10px] uppercase tracking-[0.28em] text-[#FFC72C] font-semibold mb-2">
                Escaneie com a câmera
              </div>
              <div className="font-serif-display text-2xl md:text-3xl">{SITE.instagramHandle}</div>
              <div className="text-xs uppercase tracking-widest text-white/50 mt-3">
                Aponte o celular pro QR Code
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="relative z-10 border-t border-white/10 px-6 md:px-12 py-6 text-center text-xs text-white/40">
        © {new Date().getFullYear()} {SITE.name} · Procurador Municipal · {SITE.city}
      </footer>
    </div>
  );
}
